import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useAppTranslation } from "../TranslationContext";
import s from "./Login.module.css";


export const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useAppTranslation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState(''); // пока не используется в API, но оставим для интерфейса

  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const extractError = (errObj) => {
      if (!errObj) return 'Ошибка авторизации';
      // dj-rest-auth / allauth обычно кладут ошибки сюда:
      const first = errObj.non_field_errors?.[0]
        || errObj.detail
        || errObj.email?.[0]
        || errObj.username?.[0]
        || errObj.login?.[0]
        || errObj.password?.[0]
        || errObj.message;
      return typeof first === 'string' ? first : 'Ошибка авторизации';
    };
  
    // кандидаты полезной нагрузки: пробуем по очереди
    const candidates = [];
    if (email.trim()) candidates.push({ email: email.trim(), password });
    if (username.trim()) candidates.push({ username: username.trim(), password });
  
    // На случай настройки ACCOUNT_AUTHENTICATION_METHOD='username_email'
    const loginValue = (username || email).trim();
    if (loginValue) candidates.push({ login: loginValue, password });
  
    let token = null;
    let lastError = null;
  
    for (const payload of candidates) {
      try {
        const res = await fetch('https://api.eduskill.uz/api/v1/dj-rest-auth/login/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
        });
  
        const data = await res.json();
  
        if (!res.ok) {
          lastError = extractError(data);
          // Если ошибка явно про «не тот набор полей», пробуем следующего кандидата
          continue;
        }
  
        token = data?.key;
        if (!token) {
          lastError = 'Токен не получен';
          continue;
        }
        break; // успех
      } catch (err) {
        lastError = 'Сервер не отвечает. Попробуйте позже.';
      }
    }
  
    if (!token) {
      alert(lastError || 'Неверный логин или пароль');
      return;
    }
  
    try {
      // Получаем профиль текущего пользователя по токену
      const profileRes = await fetch('https://api.eduskill.uz/api/v1/dj-rest-auth/user/', {
        headers: { 'Authorization': 'Token ' + token, 'Accept': 'application/json' },
      });
  
      const user = await profileRes.json();
      if (!profileRes.ok) {
        alert(extractError(user) || 'Не удалось получить профиль');
        return;
      }
  
      const userWithId = { ...user, id: user.pk }; // переименуем pk -> id
      delete userWithId.pk;
  
      login({ token, user: userWithId });
      localStorage.setItem('token', token);
  
      navigate('/dashboard');
    } catch (err) {
      alert('Сервер не отвечает. Попробуйте позже.');
    }
  };
  

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className={s.wrapper}>
          <div className={s.loginBox}>
            <h2 className={s.loginBox__title}>{t('login')}</h2>

            {/* Inputs */}
            <div className={s.inputGroup}>
              {/* Username (не используется, но оставим визуально) */}
              <div className={s.inputWrapper}>
               <label className={s.label}>{t('Username')}</label>
                <input
                  type="text"
                  value={username}
                  placeholder=" "
                  className={s.input}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>

              {/* Email */}
              <div className={s.inputWrapper}>
                
                <label className={s.label}>{t('Email')}</label>
                <input
                  type="email"
                  value={email}
                  required
                  placeholder=" "
                  className={s.input}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              {/* Password */}
              <div className={s.inputWrapper}>
                <label className={s.label}>{t('Password')}</label>
                <input
                  type="password"
                  value={password}
                  required
                  placeholder=" "
                  className={s.input}
                  onChange={(e) => setPassword(e.target.value)}
                />
                
              </div>

              
            </div>

            {/* Forgot */}
            {/* <div className={s.forgotPassword}>
              <a href="#">I don't remember the password</a>
            </div> */}

            {/* Buttons */}
            <div className={s.buttonGroup}>
              <button type='submit' className={s.loginBtn}>{t('login')}</button>
              <Link to="/register" className={s.registerBtn}>{t('createProfile')}</Link>
            </div>

          </div>
        </div>
      </form>
    </>
  );
};
